import BookEarlyCards from "./BookEarlyCards";
import { BookEarlyItems, BookEarlyItemsV2 } from "./utils";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";

import styles from "./BookEarlySection.module.scss";
import Image from "@Components/Image";
import config from "@Config/index";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";

const BookEarlySection = ({ withFullWidth = false, isDesktop = false }: any) => {
  const { t } = useTranslationHook();
  const hassleFreeText = t("searchpage.bookearlysection.hasslefreetext");
  return (
    <div
      className={formatClassNames(
        styles.outerContainer,
        isDesktop ? styles.desktop : "",
        withFullWidth ? styles.fullWidth : "",
      )}
      data-testid="searchPage-book-early-and-get-benefits-section"
    >
      {isDesktop && !withFullWidth && <div className={styles.radialGradient} />}
      <div className={styles.title} data-testid="searchPage-book-early-and-get-benefits-header">
        {isDesktop
          ? t("searchpage.bookearlysection.bookearlytitledesktop")
          : t("searchpage.bookearlysection.bookearlytitle")}
        {isDesktop && (
          <Image
            src={`${config.IMAGE_STATIC_URL}/images/fire_animation.gif`}
            width="auto"
            height={withFullWidth ? "35px" : "29px"}
          />
        )}
      </div>
      {isDesktop && withFullWidth && <div className={styles.subTitle}>{hassleFreeText}</div>}
      <div className={styles.BookEarlySectionOuter} data-testid="searchPage-book-early-cards">
        {(isDesktop ? BookEarlyItemsV2(t) : BookEarlyItems(t)).map(
          ({ imgSrc, subTitle, content }, index) => (
            <BookEarlyCards
              key={index}
              imgSrc={imgSrc}
              subTitle={subTitle}
              content={content}
              withFullWidth={withFullWidth}
              dataTestId="book-early-card"
            />
          ),
        )}
      </div>
    </div>
  );
};

export default wrapperHOC(BookEarlySection, {
  componentName: "BookEarlySection-SearchPage",
  showForChina: true,
});
